module.exports = __webpack_public_path__ + "img/login-v2.4b8c03c2.svg";